import { useState, useEffect, useCallback } from 'react';
import {
  ArrowLeft, Save, Eye, Globe, Upload, Plus, Trash2,
  GripVertical, Image, Video, Music, Calendar, Mail,
  User, Layout, Palette, Settings, ExternalLink, Newspaper, Copy, Quote, Star,
  Briefcase, Users, HelpCircle, MessageSquare, Phone, CheckCircle2, XCircle, AlertTriangle, Link, RefreshCw
} from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';
import { Label } from '@/components/ui/label';
import { Switch } from '@/components/ui/switch';
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue
} from '@/components/ui/select';
import { toast } from 'sonner';
import { cn } from '@/lib/utils';
import api from '@/lib/api';
import CloudinaryUploader, { GalleryUploader } from '@/components/CloudinaryUploader';

export const MailingListModuleEditor = ({ data, onChange, siteId }) => {
  const [subscriberCount, setSubscriberCount] = useState(null);

  useEffect(() => {
    if (siteId) {
      api.get(`/sites/${siteId}/subscribers`).then(res => {
        setSubscriberCount(res.data.total ?? 0);
      }).catch(() => {});
    }
  }, [siteId]);

  return (
    <div className="space-y-6">
      {/* Subscriber Stats */}
      {subscriberCount !== null && (
        <div className="flex items-center gap-3 p-4 bg-emerald-50 border border-emerald-200 rounded-lg">
          <div className="w-10 h-10 rounded-full bg-emerald-100 flex items-center justify-center">
            <Users className="w-5 h-5 text-emerald-600" />
          </div>
          <div>
            <p className="text-lg font-bold text-emerald-800">{subscriberCount}</p>
            <p className="text-xs text-emerald-600">Active subscribers</p>
          </div>
        </div>
      )}

      <div className="space-y-2">
        <Label>Section Title</Label>
        <Input 
          value={data.title || 'Stay Updated'} 
          onChange={(e) => onChange({...data, title: e.target.value})}
        />
      </div>
      
      <div className="space-y-2">
        <Label>Subtitle</Label>
        <Input 
          value={data.subtitle || 'Join the mailing list for news and updates'} 
          onChange={(e) => onChange({...data, subtitle: e.target.value})}
        />
      </div>

      <div className="space-y-2">
        <Label>Button Text</Label>
        <Input 
          value={data.button_text || 'Subscribe'} 
          onChange={(e) => onChange({...data, button_text: e.target.value})}
        />
      </div>

      <div className="space-y-2">
        <Label>Success Message</Label>
        <Input 
          value={data.success_message || 'Thanks for subscribing!'} 
          onChange={(e) => onChange({...data, success_message: e.target.value})}
        />
      </div>

      <div className="flex items-center gap-3 p-3 bg-slate-800 rounded-lg">
        <Switch 
          checked={data.collect_name || false}
          onCheckedChange={(v) => onChange({...data, collect_name: v})}
        />
        <Label className="text-sm text-white cursor-pointer">Also collect subscriber name</Label>
      </div>
    </div>
  );
};

// Press/Media Module Editor

